import {handleMessage, requestMessage} from '@business/messages';
import {BaseBloc} from '@core/utils/bloc';
import {Repository} from '@core/utils/repository';
import {showDeleteConfirmation} from '@modules/common';
import {switchMap, map} from 'rxjs/operators';
import {R} from '@core/utils/r';
import {SystemCalendarId, SystemCalendarResponse} from "@business/entities/system_calendar";
import {SystemCalendarAPI} from "@business/api/system_calendar";

export class SystemCalendarBloc extends BaseBloc {
    private readonly systemCalendarRepo = new Repository<SystemCalendarResponse>({
        getItemId: item => item.id,
    });

    readonly systemCalendars$ = this.systemCalendarRepo.items$.pipe(map(items => R.sortBy(items, item => item.title.toLowerCase())));

    onReset() {
        this.systemCalendarRepo.reset();
    }

    fetchSystemCalendars = () => {
        return SystemCalendarAPI.fetchSystemCalendars().pipe(this.systemCalendarRepo.ops.reset(), handleMessage({error: requestMessage('fetch_system_calendars_error')}));
    };

    createSystemCalendar = (title: string) => {
        return SystemCalendarAPI.createSystemCalendar(title).pipe(
            this.systemCalendarRepo.ops.addOne(item => item),
            handleMessage({
                type: requestMessage('create_system_calendar'),
            }),
        );
    };

    updateSystemCalendar = (id: SystemCalendarId, title: string) => {
        return SystemCalendarAPI.updateSystemCalendar(id, title).pipe(
            this.systemCalendarRepo.ops.upsertOne(item => ({item})),
            handleMessage({
                type: requestMessage('update_system_calendar'),
            }),
        );
    };

    deleteSystemCalendar = (id: SystemCalendarId) => {
        return showDeleteConfirmation('Delete Calendar', 'Do you really want to remove this calendar?').pipe(
            switchMap(() => SystemCalendarAPI.deleteSystemCalendar(id)),
            this.systemCalendarRepo.ops.removeOne(() => id),
            handleMessage({
                type: requestMessage('delete_system_calendar'),
            }),
        );
    };
}
